import { BaseMenu } from './BaseMenu';
import { IControlParameters } from '@Common/Controls/BaseControl';

export class Tree extends BaseMenu {
    constructor(param?: IControlParameters) {
        super(param);
    }

    protected _init() {
        super._init();
        this._root.addClass('tree');
        // open-by-click class, added for make pointer cursor on arrow
        this.param.openByClick && this._root.addClass('open-by-click');
    }

    public getMinRightWidth(): number {
        const visibleLis = [];

        function find(items: any[]) {
            _(items)
                .filter(i => i.control && i.control.name)
                .forEach((i: any) => {
                    i.control.name.is(':visible') && visibleLis.push(i);
                    i.children && i.children.length && find(i.children);
                });
        }

        find(this.nodes());

        let maxWidth = 0;
        const rootLeft = this._root.offset().left;

        _(visibleLis).forEach(
            function (i) {
                const name = i.control.name;
                const nameLeft = name.offset().left;
                name.css({ width: 'auto' });

                const wasBlock = name.css('display') == 'block';
                wasBlock && name.css({ display: 'inline' });

                const t = name.outerWidth(true) + (nameLeft - rootLeft) + this.param.iconWidth;

                name.css({ width: '100%' });

                wasBlock && name.css({ display: 'block' });

                if (t > maxWidth) {
                    maxWidth = t;
                }
            }.bind(this)
        );

        if (maxWidth) {
            return maxWidth;
        }

        return 0;
    }

    public adjust(width?, height?) {
        let lock = false;
        width != null && this._root.outerWidth(width);
        height != null && this._root.outerHeight(height);

        if (this.items() && this.items().length) {
            !this.scroll && this._createIScroll();
            lock = true;
            this.scroll.refresh(
                function () {
                    if (!lock && this._root.elementInDOM() && !this.scroll.vScrollbar && this._param.addItemsUntillScroll) {
                        this._onScrolledToEnd();
                        lock = false;
                    }
                }.bind(this)
            );

            this._root.toggleClass('scrollable', this._rootUl.height() > this._root.height());
        }
    }

    public addTreeArrow(node) {
        const item = node.data;

        const arrow = document.createElement('span');
        arrow.className = 'arrow';
        arrow.addEventListener('click', e => {
            if (!this.param.openByClick || item.expandOnClick === false) {
                e.stopPropagation();
                //node.control.liContent.attr('tabindex', this.tabIndex);
                (node.hasChildren || item.dynamic === true) && this._treeArrowClick(node);
            }
        });
        node.control.liContent.append(arrow);

        ((node.data.children && node.data.children.length) || item.dynamic === true) && node.control.showArrow();
    }

    protected _loadDynamicItems(node, ready?) {
        const li = node.control.li;
        const item = node.data;

        li.addClass('loading');

        // create spinner
        const spinner = document.createElement('div');
        spinner.className = 'loader-holder';
        const spinnerHolder = $(spinner).appendTo(li.children('.li-content'));
        const spinnerHeight = li.children('.li-content').height();
        const spinnerPadding = 8;
        const spinnerSize = spinnerHeight - spinnerPadding;
        spinnerHolder.outerHeight(spinnerSize);
        spinnerHolder.css({
            marginTop: spinnerPadding / 2,
            marginRight: spinnerPadding / 2,
            width: spinnerSize
        });

        spinnerHolder.spinnerStart({
            isSmall: true,
            showBackground: false,
            loadingTimeout: 0
        });
        node.control.hideArrow();

        this.getDynamicItems(
            { item: item },
            function (data) {
                if (data && data.loadCanceled) {
                    li.removeClass('loading');
                    spinnerHolder.remove();
                    node.control.showArrow();
                    ready && ready();
                    return;
                }
                item.dinamicIsLoaded = true;

                const dynamicResult = $.extend(
                    {
                        dynamicItems: [],
                        openNode: true,
                        clearNode: false
                    },
                    data
                );

                // clear node
                dynamicResult.clearNode && node.clear();

                if (dynamicResult.dynamicItems.length > 0) {
                    const oldSelected = this._treeStore.selectedItems();
                    item.children = dynamicResult.dynamicItems;
                    node.update(item);
                    this.selectedItems(oldSelected);
                }

                // expan node
                dynamicResult.openNode && node.expand(); // li.addClass('opened');

                li.removeClass('loading');
                spinnerHolder.remove();
                node.control.showArrow();
                this.setNodesVisibility();
                this.adjust();

                ready && ready();
            }.bind(this)
        );
    }

    protected _treeArrowClick(node, arrow?) {
        const li = node.control.li;
        const item = node.data;

        if (node.expanded) {
            node.collapse();
        } else if (item.dynamic && !item.dinamicIsLoaded) {
            this._loadDynamicItems(node);
        } else if (!node.expanded && node.hasChildren) {
            node.expand();
        }
    }

    /* Expand/Collapse */
    public expandAll() {
        function expand(items) {
            _(items).forEach(function (i) {
                if (i.children && i.children.length) {
                    expand(i.children);
                }

                i.hasChildren && i.expand({ needAdjust: false });
            });
        }

        expand(this._treeStore.nodes());
        this.adjust();
    }

    public expandLevel(level?) {
        if (level === undefined) {
            level = 0;
        }

        let nodesForExpand = null;

        function find(nodes) {
            _(nodes).forEach(function (node) {
                if (node.level == level) {
                    nodesForExpand = nodes;
                    return false;
                } else {
                    find(node.children || []);
                }
            });
        }

        find(this._treeStore.nodes());

        if (nodesForExpand && nodesForExpand.length) {
            _(nodesForExpand).forEach(function (node) {
                node.expand({ needAdjust: false });
            });
        }

        this.adjust();
    }

    public collapseLevel(level) {
        if (level === undefined) {
            level = 0;
        }

        let nodesForCollapse = null;

        function find(nodes) {
            _(nodes).forEach(function (node) {
                if (node.level == level) {
                    nodesForCollapse = nodes;
                    return false;
                } else {
                    find(node.children || []);
                }
            });
        }

        find(this._treeStore.nodes());

        if (nodesForCollapse && nodesForCollapse.length) {
            _(nodesForCollapse).forEach(function (node) {
                node.collapse({ needAdjust: false });
            });
        }

        this.adjust();
    }

    public collapseAll() {
        function collapse(items) {
            _(items).forEach(function (i) {
                if (i.children && i.children.length) {
                    collapse(i.children);
                }

                i.expanded && i.hasChildren && i.collapse({ needAdjust: false });
            });
        }

        collapse(this._treeStore.nodes());
        this.adjust();
    }
}
